import { render, staticRenderFns } from "./DialogCapture.vue?vue&type=template&id=49897e28"
import script from "./DialogCapture.vue?vue&type=script&lang=js"
export * from "./DialogCapture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports